<template>
  <v-card
      class="mx-auto" 
      max-width="700px"
    >
      <v-card-title class="custom-card">               
          <v-row align="center" justify="center">
            <v-col>
              <span class="caption">Aprieta "{{info.options[0].keyboard}}" para</span><br>
              <span v-if="info.options[0].value[0].length >0" style="color:blue;">{{info.options[0].value[0]}}<br></span>
              <span v-if="info.options[0].value[0].length >0 && info.options[0].value[1].length >0">o<br></span>
              <span style="color:green;">{{info.options[0].value[1]}}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <span class="caption">Aprieta "{{info.options[1].keyboard}}" para</span><br>
              <span v-if="info.options[1].value[0].length >0" style="color:blue;">{{info.options[1].value[0]}}<br></span>
              <span v-if="info.options[1].value[0].length >0 && info.options[0].value[1].length >0">o<br></span>
              <span style="color:green;">{{info.options[1].value[1]}}</span>
            </v-col>    
          </v-row>

      </v-card-title>
        <!-- {{index}} - {{info.serie[index]}} - {{info.base[info.serie[index]-1]}} -->
        <card-text-instructions v-if="!started" :info="info"></card-text-instructions>        
        <card-text-display-option v-else :target="info.base[info.serie[index]-1]"></card-text-display-option>
      <v-card-actions>
        <v-list-item class="grow">              
          <v-row align="center" justify="center">
            <div v-if="!started">Pulsa la tecla <b>espacio</b> cuando este listo para empezar</div>
            <v-icon v-if="wrongAnswer" color="red">mdi-close</v-icon>
          </v-row>
        </v-list-item>
      </v-card-actions>
      <!-- {{index}} -- {{info.serie.length}}
      <p v-for="ans in answers">{{ans.userId}},{{ans.part}},{{ans.q}},{{ans.value}},{{ans.startTime}},{{ans.endTime}},{{ans.errors}}</p> -->
    </v-card>
</template>

<script>

import CardTextInstructions from './CardTextInstructions'
import CardTextDisplayOption from './CardTextDisplayOption'
import { mdiClose } from '@mdi/js'

export default {
  name: 'CardQuestions',
  props: ['info'],
  components: {
    CardTextInstructions,
    CardTextDisplayOption
  },
  data: () => ({
    started: false,
    index: 0,
    wrongAnswer: false,
  }),
  mounted(){      
    window.addEventListener('keyup', this.processKeyPressed)
  },
  beforeDestroy(){
    window.removeEventListener("keyup", this.processKeyPressed)
  },  
  methods:{
    startAnswer: (partX,qIndex,qValue) => ({
      part: partX,
      q: qIndex,
      value: qValue,
      startTime: Date.now(),
      endTime: 0,
      errors: false
    }),
    endAnswer(ans){
      ans.endTime = Date.now()
      this.$store.dispatch('addAnswer',ans)
    },
    processKeyPressed(event){
      let isValid = false
      
      switch (event.key){
        case " ":
          //console.log("space -- should start timer")
          this.answer = this.startAnswer(this.info.current,this.index,this.info.serie[this.index])
          if (this.started == false)
            this.started = true
          break
        case "e":
        case "E":
          //console.log("e or E")
          if(this.started){
            isValid = this.info.options[0].valid.includes(this.info.serie[this.index])
            if (isValid){              
              this.endAnswer(this.answer)
              //console.log("Answer ended",)              
              this.index = this.index + 1
              this.wrongAnswer = false
              this.answer = this.startAnswer(this.info.current,this.index,this.info.serie[this.index])
            }else{
              this.wrongAnswer = true
              this.answer.errors = true
            }   
          }                                
          break 
        case "i":             
        case "I":
          //console.log("i or I")
          if(this.started){     
            isValid = this.info.options[1].valid.includes(this.info.serie[this.index])
            if (isValid){
              this.endAnswer(this.answer)
              //console.log("Answer ended") 
              this.index = this.index + 1
              this.wrongAnswer = false
              this.answer = this.startAnswer(this.info.current,this.index,this.info.serie[this.index])            
            }else{
              this.wrongAnswer = true
              this.answer.errors = true
            } 
          }     
          break   
      }
      if (this.index == this.info.serie.length){
        //console.log("End test")
        this.started = false
        this.index = 0
        this.wrongAnswer = false
        this.$store.dispatch('nextPart')     
      }             
    },
  },
  computed:{
    answers(){
      return this.$store.state.answers
    }
  }
};
</script>

<style>
.custom-card{
  font-family: auto;
}
.v-card__text{
  color: black !important;
}

</style>

